import SolicitarTurnos from "./SolicitarTurnos";
export default SolicitarTurnos;